import { render } from "./PodiumSection.vue?vue&type=template&id=b87544f6"
import script from "./PodiumSection.vue?vue&type=script&lang=js"
export * from "./PodiumSection.vue?vue&type=script&lang=js"

import "./PodiumSection.vue?vue&type=style&index=0&id=b87544f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__